import React, { useState, useEffect } from 'react';
import { Card, Input, Button, Skeleton } from '../../components/ui';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { AdminPanelSettings, Error as ErrorIcon } from '../../mui-icons';
import './AdminLoginPage.css';
import logoIcon from '../../assets/icon-no-name.webp';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated, loading: authLoading } = useAdminAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!authLoading && isAuthenticated()) {
      const from = location.state?.from?.pathname || '/admin';
      navigate(from, { replace: true });
    }
  }, [authLoading, isAuthenticated, navigate, location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email || !password) {
      setError('Preencha todos os campos');
      setLoading(false);
      return;
    }

    if (!email.includes('@')) {
      setError('Digite um email válido');
      setLoading(false);
      return;
    }

    try {
      await login(email, password);
      const from = location.state?.from?.pathname || '/admin';
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  if (authLoading) {
    return (
      <div className="admin-login-page surface-app">
        <div className="admin-login-container">
          <Card variant="auth" className="admin-login-skeleton-card">
            <Skeleton width={72} height={72} borderRadius={36} style={{ margin: '0 auto 16px' }} />
            <Skeleton width="70%" height={24} borderRadius={4} style={{ margin: '0 auto 12px' }} />
            <Skeleton width="90%" height={16} borderRadius={4} style={{ margin: '0 auto 24px' }} />
            <Skeleton width="100%" height={48} borderRadius={16} style={{ marginBottom: 16 }} />
            <Skeleton width="100%" height={48} borderRadius={16} />
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login-page surface-app">
      <div className="admin-login-container">
        <Card variant="auth" className="admin-login-card">
          <div className="login-logo">
            <img src={logoIcon} alt="PersonalNutri" className="login-logo-img" />
          </div>

          <div className="login-icon">
            <AdminPanelSettings sx={{ fontSize: 48, color: 'var(--color-primary)' }} />
          </div>

          <h1 className="login-title">Painel Administrativo</h1>
          <p className="login-subtitle">Acesse com suas credenciais de administrador</p>

          <form onSubmit={handleSubmit} className="login-form">
            <Input
              id="email"
              label="Email"
              type="email"
              icon="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              autoFocus
              autoComplete="email"
            />

            <Input
              id="password"
              label="Senha"
              type={showPassword ? 'text' : 'password'}
              icon="lock"
              placeholder="Digite sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              autoComplete="current-password"
              showPasswordToggle
              passwordVisible={showPassword}
              onTogglePassword={() => setShowPassword(!showPassword)}
            />

            {error && (
              <div className="error-message" role="alert">
                <ErrorIcon sx={{ fontSize: 20 }} />
                <span>{error}</span>
              </div>
            )}

            <Button type="submit" variant="primary" loading={loading} block>
              Entrar
            </Button>
          </form>

          <div className="login-footer">
            <a href="/" className="back-link">
              ← Voltar para o site
            </a>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default AdminLoginPage;
